import "./App.scss";
import Frontpage from "./components/Frontpage/Frontpage";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<Frontpage />} />
          <Route path="/nyitolap" element={<Frontpage />} />
          <Route path="/stadiontura" element={<Frontpage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
